import React from 'react';
import '../../App.css';

const FirstCellRenderer: React.FC<{value:string}> = (props) => { 
    const content = JSON.parse(props.value)
    return (
    <p className="gemu-rs-line-height-normal">
        {content.medium}<br/>
        {content.altName ? <span className="gemu-rs-font-light-grey">{content.altName}<br/></span> : null }
        <span className="gemu-rs-font-light-grey">{content.Formel}</span>
        {content.CAS_Nr ? <span className="gemu-rs-font-light-grey"> | {content.CAS_Nr}</span> : null }
        {content.Note ? <span className="gemu-rs-font-light-grey"><br/> {content.Note}</span> : null }
        
    </p>
    )
}

export default FirstCellRenderer;